import request from '@/router/axios'

export function getPostTagStatisticsSummaryData (param) {
  return request({
    url: '/post/admin/post/statistics/analysis/post/tag/summary',
    method: 'get',
    params: param,
  })
}

export function exportPostTagStatisticsSummaryData (param) {
  return request({
    url: '/post/admin/post/statistics/analysis/post/tag/summary/export',
    method: 'get',
    params: param,
  })
}